module.exports = __webpack_public_path__ + "img/sampleGraph7.75fc6ba0.png";